import React from "react"
import PropTypes from "prop-types"
import { Nav, NavItem, NavLink } from "reactstrap"

export const tabsClients = {
  generales: "generales",
  sucursales: "sucursales",
  camiones: "camiones",
}

const Tabs = ({ tabActive, setTabActive }) => {
  return (
    <div className="mt-2">
      <Nav tabs>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.generales ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.generales)
            }}
          >
            Datos Generales
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.sucursales ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.sucursales)
            }}
          >
            Sucursales
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={tabActive == tabsClients.camiones ? 'active' : ''}
            onClick={() => {
              setTabActive(tabsClients.camiones)
            }}
          >
            Camiones Capacidad
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  )
}

Tabs.propTypes = {
  tabActive: PropTypes.string,
  setTabActive: PropTypes.func,
}

export default Tabs
